namespace GeniuzPOS.Purchase {
    export enum CreditNotetype {
        refund = 1,
        discprice = 2
    }
    Serenity.Decorators.registerEnumType(CreditNotetype, 'GeniuzPOS.Purchase.CreditNotetype');
}
